import { render, staticRenderFns } from "./MultipleChargesModal.vue?vue&type=template&id=406b2a45"
import script from "./MultipleChargesModal.vue?vue&type=script&lang=js"
export * from "./MultipleChargesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports